import useQuery, { QueryOptions } from 'hooks/useQuery';
import { downloadPdfSelector as selector } from 'store/sinistre/selectors';
import { downloadPdf, downloadPdfReset } from 'store/sinistre/actions';

const useDownloadPdf = (params?: QueryOptions) =>
  useQuery({
    action: downloadPdf,
    resetAction: downloadPdfReset,
    selector,
    ...params,
  });

export default useDownloadPdf;
